import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export default function OpenNetworkProductTypeBasicInfoComponent ({handleInnerFormChange, selectedProductType}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedProductType?.Name}
          />
   <InputContainer

label="Code"

onValueChange={(event: any) => {
    handleInnerFormChange(
        event.target.value,
       'Code'
       );
}}
type="text"
value={selectedProductType?.Code}
/>
</div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}